import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowDownCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m7.69 15.69-6.89 7a1.13 1.13 0 0 1-.8.31 1.1 1.1 0 0 1-.8-.31l-6.89-7a1.07 1.07 0 0 1 0-1.5 1 1 0 0 1 1.48 0L15 21.5V8a1 1 0 1 1 2 0v13.5l5.22-5.31a1 1 0 0 1 1.48 0 1.07 1.07 0 0 1-.01 1.5" />
  </svg>
);
const ForwardRef = forwardRef(IconArrowDownCircleFilledSVG);
ForwardRef.displayName = "IconArrowDownCircleFilled";
export { ForwardRef as IconArrowDownCircleFilled };
